import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getPrimaryColor } from "./Theme";

const THEME_COLOR = getPrimaryColor("b2b");
const DEFAULT_DARK = "#2E3642";
const DEFAULT_WHITE = "#FFFFFF";
const DEFAULT_FONT = `"Noto Sans TC", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif`;

export default function ArrowButton({
  className,
  label,
  onClick,
  href,
  type = "button",

  fontFamily = DEFAULT_FONT,

  bgColor = DEFAULT_WHITE,
  textColor = DEFAULT_DARK,

  borderColor = "none",
  hoverBorderColor = THEME_COLOR,

  hoverBgColor = THEME_COLOR,
  hoverTextColor = DEFAULT_WHITE,

  arrowColor = THEME_COLOR,
  hoverArrowColor = DEFAULT_WHITE,

  borderRadius = "8px",
  borderWidth = 1,

  minHeight = { xs: 52, md: 70 },
  px = { xs: "16px", md: "24px" },

  fontSize = { xs: "15px", md: "18px" },
  fontWeight = 700,
  lineHeight = 1.2,

  textPr = { xs: "24px", md: "30px" },
  arrowRight = { xs: "14px", md: "45px" },
  arrowSize = { xs: "20px", md: "18px" },

  width = "100%",
  sx = {},
  textSx = {},
  arrowSx = {},
}) {
  const [hovered, setHovered] = useState(false);

  const Component = href ? "a" : "button";

  return (
    <Box
      className={className}
      component={Component}
      href={href}
      type={href ? undefined : type}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        width,
        minHeight,
        px,
        borderRadius,
        border:
          borderColor === "none"
            ? "none"
            : `${borderWidth}px solid ${hovered ? hoverBorderColor : borderColor}`,
        backgroundColor: hovered ? hoverBgColor : bgColor,
        color: hovered ? hoverTextColor : textColor,
        cursor: "pointer",

        outline: "none",
        boxShadow: "none",
        appearance: "none",
        WebkitAppearance: "none",
        MozAppearance: "none",
        WebkitTapHighlightColor: "transparent",
        textDecoration: "none",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        boxSizing: "border-box",
        overflow: "hidden",

        transition:
          "background-color 220ms ease, color 220ms ease, transform 220ms ease, border-color 220ms ease",

        "&, &:hover, &:focus, &:focus-visible, &:active": {
          outline: "none",
          boxShadow: "none",
          textDecoration: "none",
          border:
            borderColor === "none"
              ? "none"
              : `${borderWidth}px solid ${hovered ? hoverBorderColor : borderColor}`,
        },

        "&:focus-visible": {
          outline: "none !important",
          boxShadow: "none !important",
        },

        "&:focus": {
          outline: "none !important",
          boxShadow: "none !important",
        },

        "&:active": {
          outline: "none !important",
          boxShadow: "none !important",
        },

        "&:hover": {
          transform: "translateY(-1px)",
          backgroundColor: hoverBgColor,
          color: hoverTextColor,
        },

        "&::-moz-focus-inner": {
          border: 0,
        },

        "& .arrow-btn-icon": {
          position: "absolute",
          right: arrowRight,
          top: "50%",
          fontSize: arrowSize,
          color: hovered ? hoverArrowColor : arrowColor,
          transform: "translateY(-50%) translateX(0)",
          transition:
            "transform 260ms ease, opacity 260ms ease, color 220ms ease",
          opacity: 0.95,
          pointerEvents: "none",
        },

        "&:hover .arrow-btn-icon": {
          transform: "translateY(-50%) translateX(10px)",
          opacity: 1,
        },

        ...sx,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontFamily,
          fontWeight,
          fontSize,
          lineHeight,
          color: "inherit",
          textAlign: "center",
          pr: textPr,
          userSelect: "none",
          pointerEvents: "none",
          ...textSx,
        }}
      >
        {label}
      </Typography>

      <ArrowForwardIosIcon
        className="arrow-btn-icon"
        sx={{
          ...arrowSx,
        }}
      />
    </Box>
  );
}